export default "__VITE_ASSET__C63saJgr__"